import React, {useEffect,useContext,useState} from "react";
import { useNavigate, useLocation  } from 'react-router-dom';

import { Link } from 'react-router-dom';



import Context from '../context/context';
import ReactGA from 'react-ga4';


import Lang from '../lang/translations';


const config = require("../_helpers/configServizi"); 


export default function Navbar_mobile_new(props) {
	
	let navigate = useNavigate();


	const context = useContext(Context);	
	
	

	const [barra, setBarra] = useState("");
	const [coloreMessaggio, setColoreMessaggio] = useState("");
	const [menuaperto, setMenuaperto] = useState(false);

	var location = useLocation();
    location = location.pathname.split("/")

	const domain = window.location.hostname;
   	const url_logo = config.servizi[domain].logo_su_chiaro;
   


	useEffect(() => { 
		
		
		if(context.creditiMessaggi > 40){ setBarra("fa-battery-full");setColoreMessaggio("color_full");}
		if(context.creditiMessaggi >=20 && context.creditiMessaggi <= 40 ){ setBarra("fa-battery-half");setColoreMessaggio("color_medium");}
		if(context.creditiMessaggi < 20){setBarra("fa-battery-empty");setColoreMessaggio("color_empty");}

	},[context.creditiMessaggi]);


	//--creo una funzione che controlla se nella history del browser c'è qualcosa uso la pagina della history altrimenti mando a /chats
	function navigate_to_chats_or_history(){
		if(window.history.length > 2){
			navigate(-1);
		}else{
			navigate('chats');
		}
	}

	// React Router v6 scrive window.history.state.idx: se > 0 l'utente ha navigato
	// dentro l'app, altrimenti è arrivato da un link esterno (es. email).
	function navigate_back_or_find() {
		const idx = window.history.state?.idx;
		if(idx !== undefined && idx > 0) {
			navigate(-1);
		} else {
			navigate('/find');
		}
	}

	// onBack: handler opzionale per il bottone back; se non passato usa navigate('chats')
	function componi_menu(titolo_pagina,back,logo,onBack){
		return (<div><div className="navbar navbar-default navbar-fixed-top searchFilters" role="navigation" style={{backgroundColor:"#fff" }}>
			<div>
				 <div className="titoloPagina">
						{back && (
							<svg className="iconback" onClick={() => onBack ? onBack() : navigate('chats')}  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg>
						)}
						{logo ? (<img style={{ maxHeight: '29px', maxWidth: '150px', height: 'auto', width: 'auto' }}  src={config.servizi[domain].logo_navbar_mobile_top}></img>
						):
						(<h5><Lang w={titolo_pagina} page={"navbar_mobileNew"}/></h5>)}
						<div className="profiloMenu">
						{/*<svg  className="icon" onClick={() => navigate('/profile')} fill="#595959" viewBox="0 0 512 512"><path d="M399 384.2C376.9 345.8 335.4 320 288 320H224c-47.4 0-88.9 25.8-111 64.2c35.2 39.2 86.2 63.8 143 63.8s107.8-24.7 143-63.8zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 16a72 72 0 1 0 0-144 72 72 0 1 0 0 144z"/></svg>*/}
						{(context.premiumLevel > 0 && !logo) && (
							<svg onClick={() => navigate('/vip_plan/cred')} className="icon" fill="#ffc14a" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M512 80c0 18-14.3 34.6-38.4 48c-29.1 16.1-72.5 27.5-122.3 30.9c-3.7-1.8-7.4-3.5-11.3-5C300.6 137.4 248.2 128 192 128c-8.3 0-16.4 .2-24.5 .6l-1.1-.6C142.3 114.6 128 98 128 80c0-44.2 86-80 192-80S512 35.8 512 80zM160.7 161.1c10.2-.7 20.7-1.1 31.3-1.1c62.2 0 117.4 12.3 152.5 31.4C369.3 204.9 384 221.7 384 240c0 4-.7 7.9-2.1 11.7c-4.6 13.2-17 25.3-35 35.5c0 0 0 0 0 0c-.1 .1-.3 .1-.4 .2l0 0 0 0c-.3 .2-.6 .3-.9 .5c-35 19.4-90.8 32-153.6 32c-59.6 0-112.9-11.3-148.2-29.1c-1.9-.9-3.7-1.9-5.5-2.9C14.3 274.6 0 258 0 240c0-34.8 53.4-64.5 128-75.4c10.5-1.5 21.4-2.7 32.7-3.5zM416 240c0-21.9-10.6-39.9-24.1-53.4c28.3-4.4 54.2-11.4 76.2-20.5c16.3-6.8 31.5-15.2 43.9-25.5V176c0 19.3-16.5 37.1-43.8 50.9c-14.6 7.4-32.4 13.7-52.4 18.5c.1-1.8 .2-3.5 .2-5.3zm-32 96c0 18-14.3 34.6-38.4 48c-1.8 1-3.6 1.9-5.5 2.9C304.9 404.7 251.6 416 192 416c-62.8 0-118.6-12.6-153.6-32C14.3 370.6 0 354 0 336V300.6c12.5 10.3 27.6 18.7 43.9 25.5C83.4 342.6 135.8 352 192 352s108.6-9.4 148.1-25.9c7.8-3.2 15.3-6.9 22.4-10.9c6.1-3.4 11.8-7.2 17.2-11.2c1.5-1.1 2.9-2.3 4.3-3.4V304v5.7V336zm32 0V304 278.1c19-4.2 36.5-9.5 52.1-16c16.3-6.8 31.5-15.2 43.9-25.5V272c0 10.5-5 21-14.9 30.9c-16.3 16.3-45 29.7-81.3 38.4c.1-1.7 .2-3.5 .2-5.3zM192 448c56.2 0 108.6-9.4 148.1-25.9c16.3-6.8 31.5-15.2 43.9-25.5V432c0 44.2-86 80-192 80S0 476.2 0 432V396.6c12.5 10.3 27.6 18.7 43.9 25.5C83.4 438.6 135.8 448 192 448z"/></svg>
						)}
						
							
						</div>
				</div>
			</div>
			</div>
			</div>)
	}


	if((location[1] == "purchase")){
		return (<div><div className="navbar navbar-default navbar-fixed-top searchFilters" role="navigation" style={{backgroundColor:"#fff",minHeight:"61px" }}> 
		<div className="container">
			 <div className="navbar-header">
				 <div className="contMenuPurch">
					 	{location[2] == "choose" && (
							<a className="backPayment" onClick={() => navigate('/vip_plan/cred')} >
								<i className="fa fa-chevron-left" aria-hidden="true"></i>
							</a>
						)}
						{location[2] == "pay" && (
							<a className="backPayment" onClick={() => navigate('/vip_plan/cred')} >
								<i className="fa fa-chevron-left" aria-hidden="true"></i>
							</a>
						)}
						
						<img style={{ maxHeight: '50px', height: 'auto', width: 'auto', maxWidth: '200px', display: 'block' }} className="garanzia" src={url_logo}></img>			
					
				</div>
			</div>
		</div>
		</div>
		</div>)
	}
	if((location[1]=="chats" && location[2]!=undefined)){
		return (<div></div>)
	}if(location[1]=="chats" && location[2] == undefined){
		return (componi_menu("titolo_messaggi"))
	}if(location[1]=="notifications"){
		return (componi_menu("titolo_notifiche"))
	}if(location[1]=="profile"){
		return (componi_menu("titolo_profilo"))
	}if(location[1]=="find"){
		return (componi_menu("titolo_cerca"))
	}if(location[1]=="match"){
		return (componi_menu(null,null,"logo"))
	}if((location[1] == "vip_plan")){
		if(context.user_info.fluxId === "0000"){
			return (componi_menu("diventa_premium",true))
		}
		return (componi_menu("titolo_rateplan",true))
	}if(location[1]=="activeNotifications"){
		return (componi_menu("titolo_avvisi", true, null, navigate_back_or_find))
	}if((location[1] == "user")){
		return (componi_menu("profilo_angel", true, null, navigate_back_or_find))
	}
	else{
		return (<div><div className="navbar navbar-default navbar-fixed-top searchFilters" role="navigation">
		<div>
				<div className="navbar-header">
					<button type="button" className={"navbar-toggle"} data-toggle="offcanvas" data-target=".sidebar-nav" onClick={() => {setMenuaperto(prevCheck => !prevCheck);}}  onBlur={(e) => {setMenuaperto(false)}}>
						<span className="icon-bar"></span>
						<span className="icon-bar"></span>
						<span className="icon-bar"></span>
					</button>
				
					<Link to="/chats" className="icon nonletti" > <i className="fa fa-envelope"></i> <span className="badge badge-danger navMob">{context.messaggiNonLetti}</span></Link>
					
					{/*location[1] == "find" ? 
							(<Link className="icon region" onClick={() => {context.setMenuCambiaRegione(prevCheck => !prevCheck);}}  to="/find"><i className="fa fa-crosshairs"></i></Link>)
							:
							(<Link className="icon search"  to="/find"><i className="fa fa-search"></i></Link>)*/
					}
					
					<Link className="icon search"  to="/find"><i className="fa fa-search"></i></Link>

					<Link className="navbar-brand" to="/find"><img src={url_logo} className="img-fluid" /></Link>
					
					{context.premiumLevel == 0 ? (
						<Link  to="/profile"> <i className="fa fa-user profiloMenu"></i></Link>
					):(
						<Link to="/vip_plan/cred" className="nav-link riman" onClick={() => {context.setPaymentPageText({...context.paymentPageText,text1:""})}}><div className={"messaggiRimanentiMobile "}>
							<i className={"fa " + barra}></i>
							
							
							</div>
						</Link>
					)
					}
					
				</div>
				
		</div>
		
		</div>
		<div >
		
			<div className="row">
				<div className="col-md-12">
				</div>
			</div>
			<div className="row">
				<div className={menuaperto ? "col-xs-6 col-sm-4 col-md-3 sidebar-offcanvas active" : "col-xs-6 col-sm-4 col-md-3 sidebar-offcanvas"} >
					<ul data-spy="affix" data-offset-top="120" id="affix" className="nav nav-stacked">
						<li> <Link to="/find" onClick={() => {setMenuaperto(false)}}> <i className="fa fa-search"></i> <Lang w={"cerca"} page={"navbar_mobileNew"}/></Link></li>

						<li><Link to="/chats" onClick={() => {setMenuaperto(false)}}> <i className="fa fa-envelope"></i> <Lang w={"messaggi"} page={"navbar_mobileNew"}/> <span className="badge badge-danger">{context.messaggiNonLetti}</span></Link></li>

						<li><Link to="/profile" onClick={() => {setMenuaperto(false)}}> <i className="fa fa-user"></i> <Lang w={"profilo"} page={"navbar_mobileNew"}/></Link></li>
						{context.premiumLevel === 0 && ( 
							<li className="nav-item"><Link to="/vip_plan/cred"  onClick={() => {context.setPaymentPageText({header1:"pagamento_sicuro",header2:"dati_protetti",text1:undefined});console.log(context.paymentPageText);}} className="nav-link "><i className="fa fa-award"/>  <Lang w={"vip"} page={"navbar_mobileNew"}/></Link></li>
						)}
						{context.premiumLevel === 1 && ( 
							<li className="nav-item"><Link to="/vip_plan/cred" className="nav-link "  onClick={() => {context.setPaymentPageText({header1:"pagamento_sicuro",header2:"dati_protetti",text1:undefined});console.log(context.paymentPageText);}} ><i className="fas fa-coins" />  <Lang w={"crediti"} page={"navbar_mobileNew"}/></Link></li>
						)}
						{context.premiumLevel === 2 && ( 
							<li className="nav-item"><Link to="/vip_plan/cred" className="nav-link "  onClick={() => {context.setPaymentPageText({header1:"pagamento_sicuro",header2:"dati_protetti",text1:undefined});console.log(context.paymentPageText);}} ><i className="fas fa-coins" />  <Lang w={"crediti"} page={"navbar_mobileNew"}/></Link></li>
						)}
						<li className="nav-item"><a onClick={() => {navigate('/activeNotifications')}} className="nav-link "><i className="fab fa-telegram"></i><Lang w={"attiva_notifiche"} page={"navbar_mobileNew"}/>
						</a>
						</li>

						

						{/*
						<div className={barra} role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style={{flex: 0.2,}}>
							<Lang w={"messaggi_restanti"} page={"navbar_mobileNew"}/> {context.creditiMessaggi} <span className="menuIscriviti"> <Link onClick={() => {setMenuaperto(false)}} to="/vip_plan/sub" className="nav-link "> <Lang w={"incentive_menu"} page={"navbar_mobileNew"}/></Link></span>  
						</div>*/}
					
					</ul>
				</div>
				<div className="col-xs-12 col-sm-8 col-md-9 content">
				
				</div>
			</div>
		</div></div>);
		}
 }



